module.exports = {"TXTWCL_Max_30":{"id":"TXTWCL_Max_30","defaultMessage":"Max."}}